export const namespace = 'campaign'; 

export const Status = {
  INITIAL: 'initial',
  LOADING: 'loading',
  LOADED: 'loaded',
  ERROR: 'error'
};

export const ActionType = {
  SET_CAMPAIGNS: `${namespace}/SET_CAMPAIGNS`,
  LOAD_CAMPAIGNS: `${namespace}/LOAD_CAMPAIGNS`,
  SET_CAMPAIGN_PERMISSIONS: `${namespace}/SET_CAMPAIGN_PERMISSIONS`,
  UPDATE_CAMPAIGN_PERMISSIONS: `${namespace}/UPDATE_CAMPAIGN_PERMISSIONS`,
  SET_SELECTED_ADSOURCES: `${namespace}/SET_SELECTED_ADSOURCES`,
  SET_CAMPAIGN_CHARTDATA: `${namespace}/SET_CAMPAIGN_CHARTDATA`,
  LOAD_GEOFENCE_DATA: `${namespace}/LOAD_GEOFENCE_DATA`,
  SET_GEOLOCATION_CHILDREN: `${namespace}/SET_GEOLOCATION_CHILDREN`,
  SET_GEO_LOADING_STATUS: `${namespace}/SET_GEO_LOADING_STATUS`,
  SET_TARGET_LOCATION_PATH: `${namespace}/SET_TARGET_LOCATION_PATH`,
  REFRESH_CAMPAIGN_DATA: `${namespace}/REFRESH_CAMPAIGN_DATA`,
  SET_CAMPAIGN_PROGRESS_BAR_STATUS: `${namespace}/SET_CAMPAIGN_PROGRESS_BAR_STATUS`,
  SET_CAMPAIGN_NEW_HASH_WINDOW: `${namespace}/SET_CAMPAIGN_NEW_HASH_WINDOW`,
  LOAD_GEOFENCE_LOCATION_PATH: `${namespace}/LOAD_GEOFENCE_LOCATION_PATH`,
};

export const setTargetLocationPath = (targetLocationPath , campaignId, dateRange) => {
  return dispatch => {
    dispatch({
      payload: {targetLocationPath , campaignId, dateRange},
      type: ActionType.SET_TARGET_LOCATION_PATH
    });
  }
}

export const loadCampaigns = campaignIds => {
  return dispatch => {
    dispatch({
      payload: {campaignIds},
      type: ActionType.LOAD_CAMPAIGNS
    });
  }
}

export const setCampaigns = (campaigns, requestCampaignIds) => {
  return dispatch => {
    dispatch({
      payload: { campaigns, requestCampaignIds },
      type: ActionType.SET_CAMPAIGNS
    });
  }
}


export const setCampaignPermissions = (campaignId, permissions) => {
  return (dispatch) => {
    dispatch({
      payload: {campaignId, permissions},
      type: ActionType.SET_CAMPAIGN_PERMISSIONS
    })
  }
};

/**
 * update access permission on a campaign
 * @param {number} campaignId 
 * @param {Array<{id: string, role: string}>} permissions 
 * - role has to be either 'editor' or 'viewer'
 */
export const updateCampaignPermissions = (campaignId, permissions) => {
  return (dispatch) => {
    dispatch({
      payload: {campaignId, permissions},
      type: ActionType.UPDATE_CAMPAIGN_PERMISSIONS
    })
  }
};

export const setSelectedAdsources = (campaignId, selected) => ({
  payload: {
    campaignId,
    selected
  },
  type: ActionType.SET_SELECTED_ADSOURCES
})

export const setCampaignChartData = (chartData, campaignId, dateRange) => {
  return dispatch => {
    dispatch({
      payload: {
        chartData,
        campaignId,
        dateRange
      },
      type: ActionType.SET_CAMPAIGN_CHARTDATA
    })
  }
}

export const loadGeoFenceData = (campaign, locationIds, dateRange) => {
  return dispatch => {
    dispatch({
      payload: {
        campaign,
        locationIds,
        dateRange
      },
      type: ActionType.LOAD_GEOFENCE_DATA
    })
  }
};

export const setGeoLocationChildren = (geoData, campaignId, locationIds, dateRange ) => {
  return dispatch => {
    dispatch({
      payload: {
        geoData,
        campaignId,
        dateRange,
        locationIds
      },
      type: ActionType.SET_GEOLOCATION_CHILDREN
    })
  }
};

export const setGeoLoadingStatus = (status, campaignId, dateRange) => {
  return dispatch => {
    dispatch({
      payload: {
        status,
        campaignId,
        dateRange
      },
      type: ActionType.SET_GEO_LOADING_STATUS
    })
  }
};

export const setCampaignProgressBarStatus = (campaignId, percentComplete) => {
  return dispatch => {
    dispatch({
      payload: {
        campaignId,
        percentComplete
      },
      type: ActionType.SET_CAMPAIGN_PROGRESS_BAR_STATUS
    })
  }
};

export const setCampaignNewHashWindow = (campaignId, hashWindow) => {
  return dispatch => {
    dispatch({
      payload: {
        campaignId,
        hashWindow
      },
      type: ActionType.SET_CAMPAIGN_NEW_HASH_WINDOW
    })
  }
};

export const refreshCampaignData = (campaignId) => {
  return dispatch => {
    dispatch({
      payload: {
        campaignId,
      },
      type: ActionType.REFRESH_CAMPAIGN_DATA
    })
  }
};

export const loadDataByLocationPath = (campaign, locationIds, dateRange) => {
  return dispatch => {
    dispatch({
      payload: {
        campaign,
        locationIds,
        dateRange
      },
      type: ActionType.LOAD_GEOFENCE_LOCATION_PATH
    })
  }
};

